import {servicesListDisplayModal, servieModal} from "./servicesListDisplayModal";
import {leadSchedulerNextButton} from './leadSchedulerNextButton';
import {leadSchedulerBackButton} from './leadSchedulerBackButton';
import {serviceSearchTermApi} from "./serviceSearchTermApi";
import {getServiceType} from "./getServiceType";
import {getDisplayServicesList} from "./getDisplayServicesList";
import {getDisplayServicesResults} from "./getDisplayServicesResults";
import {phoneFormatter} from './phoneFormatter';
import {addressStateValidate} from './addressStateValidate';
import {s3upload} from './file_upload';
import {leadConfirmation} from './leadConfirmation'
import {leadConfirmationCall} from './leadConfirmationCall';
import {getState} from './getState'
import { serviceSelectionEnables } from "./serviceSelectionEnable";
declare global {
    interface Window {
        objOSGlobal: any;
    }
  }

window.objOSGlobal={};
window.objOSGlobal.requestBodyValues = {};
    
$(function (){
    $('.loader').remove();
    $('body').addClass('modal-open');
    let url = window.location.href;
    if (window.location.href.indexOf("location") > -1) {
        let urlPath = new URL(url);
        let param = new URLSearchParams(urlPath.search);
        let cid = param.get('cid');

        let utm_source = param.get('utm_source');
        let utm_campaign = param.get('utm_campaign');
        let utm_medium = param.get('utm_medium');
        
        if(cid){
            utm_source =  utm_source ? ', ' + utm_source :'';
            utm_campaign = utm_campaign ? ', ' + utm_campaign:'';
            utm_medium = utm_medium ? ', ' + utm_medium :'';
            window.objOSGlobal.requestBodyValues.CampaignName = cid + utm_source + utm_campaign + utm_medium;
        }else{
            window.objOSGlobal.requestBodyValues.CampaignName = 'N/A';
        }
        window.objOSGlobal.requestBodyValues.ReferringURL = document.referrer;
        sessionStorage.setItem('referringURL',document.referrer);
        let conceptId = param.get('concept_id');
        window.objOSGlobal.requestBodyValues.ConceptId = conceptId;
        sessionStorage.setItem("conceptID", conceptId);
        let postal = param.get('location');
        var country = window.location.href.split('/')[3] === "ca" ? "CA" : "US";
        window.objOSGlobal.requestBodyValues.Country  = country;
        localStorage.setItem("country", country);
        window.objOSGlobal.requestBodyValues.CallType = "In Bound";
        window.objOSGlobal.requestBodyValues.LeadAdditionalNoteLabel = "Chat Id";
        $('.zipcodeServiceSearch').text(postal);
        $('#service-address-screen input[name="zipcode"]').val(postal);
        $('#calendar-screen .next').addClass('disble-btn').prop('disabled', true);
        $("#contact-information-screen .next").addClass("disble-btn").prop("disabled", true);
        $("#service-address-screen .next").addClass("disble-btn").prop("disabled", true);
        $("#service-details-screen .confirm-btn").addClass("disble-btn").prop("disabled", true);
        phoneFormatter("phonenumber");
        if(conceptId !='24') {
            getState();
        }
        if(conceptId &&postal){
            postal = addSpaceInBetweenCaPostalCode(postal);
            $('.cal-inspection-fee').hide();
            window.objOSGlobal.requestBodyValues.modifier = 'Residential';
            window.objOSGlobal.requestBodyValues.serviceType = '4';
            window.objOSGlobal.requestBodyValues.ConceptCalledId = conceptId;
            localStorage.setItem("ConceptCalledId", conceptId);
            window.objOSGlobal.requestBodyValues.PostalCode = postal;
            localStorage.setItem('zipcode',postal);
            if(conceptId =='24'){
                getBranJsonValueForLead('DVW');
                $('#dvw-splash-screen').addClass('active');
                $('.dvw-modal-header').show();
                setTimeout(function(){
                    serviceSelectionEnables(postal);
                    setTimeout(() => {
                        getState(); 
                    }, 3000);
                },2000)
            }else{
                servicesListDisplayModal(postal);
                $('#service-search-page').addClass('active');
            }
        }
    }
    if ($(".search-services-form #service-list-query").length){
        $(".search-services-form #service-list-query").keyup(function(e:any){
            $(".serviceCategoryBtn").addClass("disble-btn").prop("disabled", true);
            var search_term:any = e.target.value;
            var serviceTypeName = window.objOSGlobal.requestBodyValues.serviceType;
            var serviceType =  getServiceType(serviceTypeName);
            var webLocationId = window.objOSGlobal.requestBodyValues.WebLocationId ? window.objOSGlobal.requestBodyValues.WebLocationId :18519;
            if(search_term.length>3){
                let searchServiceFlag = true;
                serviceSearchTermApi(search_term,serviceType,webLocationId,searchServiceFlag)
            }
        });
    }

    
$(document).on('change','.search-services-form .form-check input[name="chkServiceType"]',function (this:any){
    $('#service-search-row').remove();
    var serviceType = $(this).val();
    var postalCode = window.objOSGlobal.requestBodyValues.PostalCode
    window.objOSGlobal.requestBodyValues.serviceType = serviceType;
    window.objOSGlobal.requestBodyValues.modifier = $(this).siblings('.radio-text').text();
    sessionStorage.setItem('ServiceModifierValue',window.objOSGlobal.requestBodyValues.modifier);
    getDisplayServicesList(postalCode,serviceType,function(result:any,status:any,xhr:any){
        getDisplayServicesResults(result,postalCode);
    },function(data:any, status:any, error:any){
        $(".tab-pane.fieldset").removeClass("active");
        $(".no-service-screen").addClass("active");
    });
});
    // $("#calendar-screen .next").on('click', function(e:any){
    //     var currentElement = this;
    //     leadSchedulerNextButton(currentElement);
    // })
    $(document).on('click', '#schedulerWizard .js-next-btn', function(e:any) {
        var currentElement = this;
        leadSchedulerNextButton(currentElement);
    });
    $('#schedulerWizard .tab-content .tab-pane .js-previous-btn').on('click', function(e:any){
       var pane = $(this).closest('.tab-pane').attr('id');
       $('#' + pane).removeClass('active');
       if(pane === "calendar-screen"){
            $('.tab-pane.fieldset').removeClass('active');
            $('.progress, .progressbar').hide()
            $('.modal-header-two').hide();
            let conceptId = window.objOSGlobal.requestBodyValues.ConceptCalledId;
            if(servieModal.enable && conceptId =='24'){
              $('#dvw-splash-screen').addClass('active');
              $('.dvw-modal-header').show();
            }else{
                $('#schedulerWizard #service-search-page').addClass('active');
                $('.modal-header-one').show();
            }
       }else {
            leadSchedulerBackButton(pane);
       }
    });

    $('#input-service-state').off('change').on('change', function (e:any)
    {
    if (addressStateValidate())
    {
        $("#service-address-screen .next").removeClass("disble-btn").prop("disabled", false);
    } else
    {
        $("#service-address-screen .next").addClass("disble-btn").prop("disabled", true);
    }
    });
    $('#sd-reference-details').off('change').on('change', function (){ 
        var selectedItem = $(this).children("option:selected").text();
        window.objOSGlobal.requestBodyValues.HowDidYouHearAboutUs = selectedItem;
        let selectedItemObj:any;
        let nullValue:any = null;
        if(selectedItem !='') {
        if(window.objOSGlobal.requestBodyValues?.genericLeadSourcesObjData){
            selectedItemObj = window.objOSGlobal.requestBodyValues.genericLeadSourcesObjData?.find((item:any)=> item.leadSourceName === selectedItem);
        }
        if(!selectedItemObj?.referralTypeId) {
            window.objOSGlobal.requestBodyValues.NeighborlyLeadSourceId = selectedItemObj?.syncGenericLeadSourceId?.toString();
            window.objOSGlobal.requestBodyValues.ReferralTypeId = nullValue;
            window.objOSGlobal.requestBodyValues.ReferralType = nullValue;
        } else {
            window.objOSGlobal.requestBodyValues.NeighborlyLeadSourceId = nullValue;
            window.objOSGlobal.requestBodyValues.ReferralTypeId = selectedItemObj?.referralTypeId;
            window.objOSGlobal.requestBodyValues.ReferralType =   selectedItemObj?.leadSourceName;
        }
      }
        if(selectedItem !='' && selectedItem !="Where did you hear about us?"){
            $('.confirm-btn').removeClass("disble-btn").prop('disabled', false);
        } else {
            $('.confirm-btn').addClass("disble-btn").prop('disabled', true);
        }
    });
     //Lead confimation
    $('.confirm-btn').on('click', function () {
        if(window.location.href.toLowerCase().indexOf("mr-handyman") !== -1 || window.location.href.toLowerCase().indexOf("grounds-guys")){
            s3upload(function(){
                leadConfirmation();
            })
        }else{
            leadConfirmation();
        }

	});
	if (window.location.href.indexOf("lead-confirmation-page") > -1) {
        leadConfirmationCall();
	}
    $('.retHome').on('click', function(e) {
        e.preventDefault();
        let referrerUrl = sessionStorage.getItem('referringURL');
        window.location.href = referrerUrl;
    })

    $('.js-closeServiceModal').on('click', function (){
        window.location.href = document.referrer;
    });
})


$('.close-location input').click(function(e:any){
    window.location.href = document.referrer;
});

$('#dvw-splash-screen .js-next-btn').on('click',function(){
    serviceSelectionEnables(window.objOSGlobal.requestBodyValues.PostalCode);
});

$('#dvw-splash-screen .js-previous-btn').on('click',function(){
    window.objOSGlobal.requestBodyValues.ReferringURL;
});

export function getBranJsonValueForLead(brandCode:any){
    var brands = window.objOSGlobal.requestBodyValues.Country == 'CA' ? "/ca/en-ca/_assets/brands.json" : "/us/en-us/_assets/brands.json";
    $.ajax({
        type: "GET",
        dataType: "json",
        url: brands,
        async: false, 
        success: function(result:any) {
            if (result.length > 0) {
                var item:any = $.grep(result, function (e:any) { return e.code === brandCode  });
                if(item.length) {
                   $('#dvw-splash-screen h2.head-title').html(item[0].splash_title);
                   $('#dvw-splash-screen p.head-sub-title').html(item[0].splash_sub_title);
                }
            }
        }
    });
}


export function addSpaceInBetweenCaPostalCode(postal:any){
    if(checkingCaPostalCode(postal)){
        postal = postal.indexOf(" ") == -1 ? postal.replace(/^(.{3})(.*)$/, "$1 $2") : postal;
    }
    return postal;
}
function checkingCaPostalCode(pcVal:any) {
    return /[A-Za-z][0-9][A-Za-z]\s{0,1}[0-9][A-Za-z][0-9]$/.test(pcVal);
}